import { render, staticRenderFns } from "./uploadVideo.vue?vue&type=template&id=47db8b59&scoped=true"
import script from "./uploadVideo.vue?vue&type=script&lang=js"
export * from "./uploadVideo.vue?vue&type=script&lang=js"
import style0 from "./uploadVideo.vue?vue&type=style&index=0&id=47db8b59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db8b59",
  null
  
)

export default component.exports